import {getGroupProduct, getSalaryDeductionOccupationClassInfo} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as GLTerm from 'ApplicationEntry/ducks/ProductsRiders/glterm';
import * as UL from 'ApplicationEntry/ducks/ProductsRiders/universalLife';
import * as IWL from 'ApplicationEntry/ducks/ProductsRiders/iwl';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {
  SalaryDeductionOccupationClassInfo,
  SalaryDeductionOccupationClassInfoWarning,
} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';
import { cons } from 'fp-ts/lib/Array';
import glterm, * as GLActions from 'ApplicationEntry/ducks/ProductsRiders/glterm';

function* getSalaryDeductionOccupationClass() {
  yield takeLatest(IWL.IWLActionType.GET_OCC_CLASS, function*(action: ReturnType<typeof IWL.getOccClass>) {
    const {payload} = action;
    const {caseNumber, plan} = payload;
    const {life70Name} = plan;

    if (caseNumber === '') {
      yield put(IWL.changeOccClass(new SalaryDeductionOccupationClassInfoWarning('A case number was not entered.')));
    } else {
      const response: AsyncResult<SalaryDeductionOccupationClassInfo> = yield call(
        getSalaryDeductionOccupationClassInfo,
        caseNumber,
        life70Name!
      );

      if (E.isRight(response)) {
        yield put(IWL.changeOccClass(new Loaded(response.right)));
      } else if (response.left.key === 'Unauthorized') {
        yield put(push(ApplicationEntryRouteConstants.AWDLogin));
      } else {
        if (
          response.left.key === 'NotFound' &&
          response.left.errorDetails!.messages.some(
            (m: {message: string; responseSeverity: string}) =>
              m.message === 'Description: Salary deduction information for the provided input was not found.'
          )
        ) {
          yield put(
            IWL.changeOccClass(
              new SalaryDeductionOccupationClassInfoWarning(
                'An occupation class that is based on the provided arguments could not be found.'
              )
            )
          );
        } else {
          yield put(IWL.changeOccClass(response.left));
        }
      }
    }
  });
}

function* getULPackages() {
  yield takeLatest(UL.ULActionType.GET_PACKAGE_LIST, function*(action: ReturnType<typeof UL.getPackageList>) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;

    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(UL.changePackageList(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(UL.changePackageList(response.left));
    }
  });
}

type GLTermPackage = {
  longTermAccel: any;
  longTermAccelExtension: any;
  longTermAccelRestoration: any;
  longTermAccelRestorationExtension: any;
  payorWaiver: any;
  adb: any;
};

function* getGLTermPackages() {
  yield takeLatest(GLTerm.GLTERMActionType.GET_PACKAGE_LIST, function*(
    action: ReturnType<typeof GLTerm.getPackageList>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;

    const response: AsyncResult<{packages: GLTermPackage[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(GLTerm.changePackageList(new Loaded(response.right.packages)));
      let GTLCLTC = response.right.packages[0].longTermAccel;
      let GTLCLTCE = response.right.packages[0].longTermAccelExtension;
      let GTLCLTCR = response.right.packages[0].longTermAccelRestoration;
      let GTLCLTCRE = response.right.packages[0].longTermAccelRestorationExtension;
      let PW = response.right.packages[0].payorWaiver;
      let ADB = response.right.packages[0].adb;
      let PW1;
      if(PW == 0){
        PW1 = true;
        yield put(GLActions.changeRiderInformation(1, 'GTLCPWP', 4));
      } else {
        PW1 = false;
      }
      let PWtoString = String(PW);
      yield put(GLTerm.changeWavierValue(PWtoString));
      yield put(GLTerm.changeWaiver(PW1));
      
      let ADB1;
      if (ADB == 0) {
        ADB1 = true;
      } else {
        ADB1 = false;
      }
      yield put(GLTerm.changeADBValue(ADB));
      yield put(GLTerm.changeADB(ADB1));
      yield put(GLTerm.getGTLCLTC(GTLCLTC));
      yield put(GLTerm.getGTLCLTCE(GTLCLTCE));
      yield put(GLTerm.getGTLCLTCR(GTLCLTCR));
      yield put(GLTerm.getGTLCLTCRE(GTLCLTCRE));      
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(GLTerm.changePackageList(response.left));
    }
  });
}

function* getIWLPackages() {
  yield takeLatest(IWL.IWLActionType.GET_PACKAGE_LIST, function*(action: ReturnType<typeof IWL.getPackageList>) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;

    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(IWL.changePackageList(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(IWL.changePackageList(response.left));
    }
  });
}

function* getGLTERMSalaryDeductionOccupationClass() {
  yield takeLatest(GLTerm.GLTERMActionType.GET_OCC_CLASS, function*(action: ReturnType<typeof GLTerm.getOccClass>) {
    const {payload} = action;
    const {caseNumber, plan} = payload;
    const {life70Name} = plan;

    if (caseNumber === '') {
      yield put(GLTerm.changeOccClass(new SalaryDeductionOccupationClassInfoWarning('A case number was not entered.')));
    } else {
      const response: AsyncResult<SalaryDeductionOccupationClassInfo> = yield call(
        getSalaryDeductionOccupationClassInfo,
        caseNumber,
        life70Name!
      );
      if (E.isRight(response)) {
        yield put(GLTerm.changeOccClass(new Loaded(response.right)));
      } else if (response.left.key === 'Unauthorized') {
        yield put(push(ApplicationEntryRouteConstants.AWDLogin));
      } else {
        if (
          response.left.key === 'NotFound' &&
          response.left.errorDetails!.messages.some(
            (m: {message: string; responseSeverity: string}) =>
              m.message === 'Description: Salary deduction information for the provided input was not found.'
          )
        ) {
          yield put(
            GLTerm.changeOccClass(
              new SalaryDeductionOccupationClassInfoWarning(
                'An occupation class that is based on the provided arguments could not be found.'
              )
            )
          );
        } else {
          yield put(GLTerm.changeOccClass(response.left));
        }
      }
    }
  });
}

export default function*() {
  yield all([getULPackages(), getGLTermPackages(), getSalaryDeductionOccupationClass(), getIWLPackages(), getGLTERMSalaryDeductionOccupationClass()]);
}
function dispatch(arg0: any) {
  throw new Error('Function not implemented.');
}
